<template>
    <div class="container">
        <div class="wrap" style="margin-top: 10px" @click="back">
            <img style="width: 32px; height: 32px; margin-left: 10px; margin-top: 4px;" src="../../../assets/back.png" />
        </div>

        <div class="wrap" style="margin-top: 10px">
            <div class="wrap_title">
                <div class="title_dot"></div>
                <span style="margin-left: 6px; font-weight: 400; font-size: 17px;">充值问题</span>

                <!-- <div style="flex: 1; background-color: green;"></div> -->
                <!-- <span style="margin-right: 20px; font-weight: 500; font-size: 17px; color: #4169E1" @click="goSample">【防骗指南】</span> -->
            </div>

            <div class="content_wrap">
                <div @click="onPress(1)" class="p_title">
                    <span class="title_text">充值后可以退款吗？</span>
                    <span style="flex:1"></span>
                    <img v-if="question1" class="title_arrow" src="../../../assets/warning/ic_open.png" />
                    <img v-else class="title_arrow" src="../../../assets/warning/ic_close.png" />
                </div>
                <div v-if="question1" class="p_content">
                    <div class="line"></div>
                    非常抱歉呢，虚拟货币一经充值成功，不支持退款哦，已充值的金币，您可以选择通过聊天/赠送礼物的方式进行消费使用。
                </div>
            </div>

            <div class="content_wrap">
                <div @click="onPress(2)" class="p_title">
                    <span class="title_text">绑定金币怎么使用？</span>
                    <span style="flex:1"></span>
                    <img v-if="question2" class="title_arrow" src="../../../assets/warning/ic_open.png" />
                    <img v-else class="title_arrow" src="../../../assets/warning/ic_close.png" />
                </div>
                <div v-if="question2" class="p_content">
                    <div class="line"></div>
                    绑定金币可通过每日签到、完成任务等方式获得，绑定金币只可用于私聊及音视频通话，不可用于赠送礼物喔~
                </div>
            </div>

            <div class="content_wrap">
                <div @click="onPress(3)" class="p_title">
                    <span class="title_text">我开通了贵族为什么聊天还要金币？</span>
                    <span style="flex:1"></span>
                    <img v-if="question3" class="title_arrow" src="../../../assets/warning/ic_open.png" />
                    <img v-else class="title_arrow" src="../../../assets/warning/ic_close.png" />
                </div>
                <div v-if="question3" class="p_content">
                    <div class="line"></div>
                    贵族是您账户的尊贵体现，开通贵族可以享有相应的贵族权益，权益中并不包含免费畅聊哟~具体的权益介绍请以贵族中心页面显示的为准。
                </div>
            </div>

            

        <div style="margin-bottom: 100px">
        </div>

        </div>

        <!-- <div class="kefu" style="" @click="kefu">
            <span style="font-size: 16px; color: white;">联系在线客服</span>
            <img v-if="isVip" class="kefu_vip" src="../imgs/icon_vip.png" />
        </div> -->
    </div>
</template>


<script>
import { sha256_digest } from '../../../common/sha256';
import { IMG_COMMON, IMG_FAQ_1, IMG_FAQ_2, IMG_FAQ_3, IMG_FAQ_4, IMG_FAQ_5 } from '../consts';

export default {
    data() {
        return {
            question1: false,
            question2: false,
            question3: false,
            question4: false,
            question5: false,
            question6: false,
            question7: false,
            question8: false,
            question9: false,
            question10: false,
            question11: false,

            question12: false,  // 付费规则
            question13: false,  // 联系方式成功发送标准
            question14: false,  // 发地址为什么对方看不到

            id: '',
            name: '',
            // gender: '',
            isCheck: false,
            hideButton: '',
            pay: 0,
            complain: 0,
            complainId: 0,
            isVip: false,

            imgs: [],
            isFemale: false,
        }
    },

    created() {
        const url = window.location.href;
        const z = url.split('?');
        let p = {};

        try {
            const k = z[1].split('&');
            k.forEach(item => {
                const m = item.split('=');
                p[m[0]] = m[1];
            })
            this.id = p.id;
            this.name = p.name;
            // this.hideButton = p.gender == 2 && p.isCheck == 0;
            this.hideButton = false;
            this.isCheck = p.isCheck == 1;
            this.pay = p.pay == undefined ? -1 : p.pay;
            this.complain = p.complain == 1;
            this.complainId = p.complainId;
            this.isVip = p.vip > 0;

            this.isFemale = p.gender == 2;
        } catch(e) {}

        this.imgs = IMG_FAQ_5;
        // console.log('var si - - - -- - - ->', this.id, this.name, this.showServiceButton);
    },

    mounted() {
        
    },

    methods: {
        onPress(value) {
            // console.log('value si htis- - - - - - - - >', value);
            switch(value) {
                case 1:
                    this.question1 = !this.question1;
                    break;

                case 2:
                    this.question2 = !this.question2;
                    break;

                case 3:
                    this.question3 = !this.question3;
                    break;

                case 4:
                    this.question4 = !this.question4;
                    break;

                case 5:
                    this.question5 = !this.question5;
                    break;

                case 6:
                    this.question6 = !this.question6;
                    break;

                case 7:
                    this.question7 = !this.question7;
                    break;

                case 8:
                    this.question8 = !this.question8;
                    break;

                case 9:
                    this.question9 = !this.question9;
                    break;

                case 10:
                    this.question10 = !this.question10;
                    break;
                
                case 11:
                    this.question11 = !this.question11;
                    break;

                case 12:
                    this.question12 = !this.question12;
                    break;

                case 13:
                    this.question13 = !this.question13;
                    break;

                case 14:
                    this.question14 = !this.question14;
                    break;

                default:
                    break;
            }
        },

        kefu() {
            let url = '';
            if (this.id) {
                const nonce = 189823;
                const ts = (new Date()).getTime();
                const web_token = `${this.id}`;
                const key = 'de2099f7864d03102b3a2fdd4369d1b4';
                let sign_str = `nonce=${nonce}&timestamp=${ts}&web_token=${web_token}&${key}`;
                sign_str = sha256_digest(sign_str);
                sign_str = sign_str.toUpperCase();
                const complain = this.complain ? `[投诉:${this.complainId}]_` : '';
                const pay = this.pay != -1 ? `[¥:${this.pay}]_` : '';
                const check = this.isCheck ? `[审核人员]_` : '';
                const gender = this.isFemale ? '_女' : '_男';

                const cName = `TM:${check}${complain}${pay}${this.name}_id:${this.id}${gender}`;
                // console.log('cName ish tis- - - - -- ->', cName);
                url = `https://1894876.s4.udesk.cn/im_client/?web_plugin_id=32596&nonce=${nonce}&timestamp=${ts}&web_token=${web_token}&signature=${sign_str}&encryption_algorithm=SHA256&c_name=${cName}`;
            } else {
                url = `https://1894876.s4.udesk.cn/im_client/?web_plugin_id=32596&`;
            }
            // console.log('url si hti - - - --  ->', url);
            window.location.href = url;
        },

        goSample() {
            window.location.href = '/warning-sample';
        },

        back() {
            window.location.href = '/faq-tm';
        }
    }
}
</script>


<style scoped>
.container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    background-color: #FFF8F8FF;
}
.wrap {
    width: 94vw;
    margin-left: 3vw;
    background-color: #FFF;
    border-radius: 15px;
    margin-top: 0vw;
}
.wrap_title {
    display: flex;
    width: 94vw;
    height: 30px;
    margin-top: 10px;
    align-items: center;
    /* background-color: pink; */
}
.title_dot {
    margin-left: 24px;
    width: 2px; 
    height: 14px; 
    border-radius: 4px;
    background-color: #7678FF
}

.content_wrap {
    width: 90vw;
    padding-top: 10px;
    padding-bottom: 10px;
    margin: 4px 10px 4px 8px;
    border-bottom: 0.2px solid #F5F5F5;
}
.p_title {
    font-size: 16px;
    font-weight: 600px;
    margin: 0px 20px 0px 20px;
    align-items: center;
    /* background-color: #FF0000; */
    /* border-bottom-width: 100px; */
    /* border: 1px solid; */
    /* border-bottom-color: #FF0000; */
    display: flex;
    color: #333;
}
.title_icon {
    width: 26px;
    height: 26px;
}
.title_icon_l {
    margin-left: -3px;
    width: 31px;
    height: 31px;
}
.title_arrow {
    width: 12px;
    height: 12px;
}
.title_text {
    font-size: 14px;
}

.p_content {
    font-size: 15px;
    font-weight: 300px;
    margin: 4px 30px;
    color: #AAA;
}
.content_desc {
    font-size: 16px;
    font-weight: 400px;
}

.img {
    width: 94vw;
    height: 26.6vw;
    margin-top: 10px;
    margin-left: 3vw;
}
.line {
    height: 1px;
    background-color: #EEE;
    margin: 6px 0px;
}

.kefu {
    position: fixed;
    display: flex;
    bottom: 20px;
    left: 10vw;
    width: 80vw;
    height: 48px;
    border-radius: 10px;
    align-items: center;
    background-color: red;
    background: -webkit-linear-gradient(
        left, #CEAFFE, #7384FF
    );
    justify-content: center;
}
.kefu_vip {
    position: absolute;
    top: 1vw;
    right: 2vw;
    width: 6vw;
    height: 6vw;
    object-fit: contain;
}



.wrap_flex {
    width: 94vw;
    margin-left: 3vw;
    padding-bottom: 10px;
    background-color: #FFF;
    border-radius: 15px;
    display: flex;
    flex-wrap: wrap;
}
.img_icon {
    width: 21vw;
    height: 21vw;
}
.img_wrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 23.5vw;
    height: 25vw;
}
.img_title {
    font-size: 12px;
    margin-top: -6px;
}
</style>